import { autoinject, Aurelia } from 'aurelia-framework';
import { activationStrategy } from 'aurelia-router';
import { PageMessageService } from "../services/page-message-service";
import { BusyService } from "../services/busy-service";
import { Router } from 'aurelia-router';
import { routes } from './routes';
import "resources/validation-rules";

@autoinject
export class App {
    environment: string;

    constructor(
        private aurelia: Aurelia,
        public busyService:  BusyService,
        private pageMessageService: PageMessageService,
        public router: Router) {
        (<any>this.aurelia).subscribe('router:navigation:complete', msg => this.onNavigationComplete(msg));

        this.environment = (<any>aurelia.host.attributes).environment.value.toLowerCase();
    }

    configureRouter(config, router) {
        config.title = 'Carrier Management Portal';
        config.options.pushState = true;
        let root = '/'
        if (this.environment == 'development') {
            root = '/auth0/';
        } 
        config.options.root = root;
        config.map(routes);
    }


    onNavigationComplete(msg) {
        if (!msg.result.completed) {
            return;
        }

        //when route changes, scroll to top of page
        window.scrollTo(0, 0);
    }

}
